import React, { useState, useEffect } from "react";
import ApiErrorPage from "../APIError";
import config from "../../config";
import fetchWithAuth from '../../services/fetchWithAuth';  

const OrganizationForm = () => {
  const [organizationName, setOrganizationName] = useState("");
  const [primaryDivisionLocal, setPrimaryDivisionLocal] = useState("");
  const [secondaryDivisionLocal, setSecondaryDivisionLocal] = useState("");
  const [apiError, setApiError] = useState(false);

  const PRIMARY_DIVISION_LOCAL = "Primary Group";
  const SECONDARY_DIVISION_LOCAL = "Secondary Group";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const baseUrl = config.API_BASE_URL;

        const endpoint = "organizations/all";
        const response = await fetchWithAuth(`${baseUrl}${endpoint}`);
        const data = await response.json();
        if (data) {
          setOrganizationName(data.organizationName || "");
          setPrimaryDivisionLocal(
            data.primaryDivisionLocal || PRIMARY_DIVISION_LOCAL
          );
          setSecondaryDivisionLocal(
            data.secondaryDivisionLocal || SECONDARY_DIVISION_LOCAL
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setApiError(true);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    setOrganizationName("");
    setPrimaryDivisionLocal(PRIMARY_DIVISION_LOCAL);
    setSecondaryDivisionLocal(SECONDARY_DIVISION_LOCAL);
  };

  if (apiError) {
    return <ApiErrorPage />;
  }

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Organization Name:
        <input
          type="text"
          defaultValue={organizationName}
          onChange={(e) => setOrganizationName(e.target.value)}
        />
      </label>
      <br />
      <label>
        Primary Division Local:
        <input
          type="text"
          defaultValue={primaryDivisionLocal}
          onChange={(e) => setPrimaryDivisionLocal(e.target.value)}
        />
      </label>
      <br />
      <label>
        Secondary Division Local:
        <input
          type="text"
          defaultValue={secondaryDivisionLocal}
          onChange={(e) => setSecondaryDivisionLocal(e.target.value)}
        />
      </label>
      <br />
      <button type="submit">Submit</button>
    </form>
  );
};

export default OrganizationForm;
